export default __webpack_public_path__ + "static/life-at-everly-684eadf9f7439f856fedcc2b52dac8f9.mp4";